import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {

  async fetchVendorList(data) 
  {
    let response = await apiCall("vendor/list", data);
    return response;
  },

  async fetchVendorListByPage(page) 
  {
    let data = {
      page: page
    };
    let response = await apiCall("vendor/list/page", data);
    return response;
  },

  async searchAllVendors(search, page, school) {
    let data = {
      search: search,
      page: page,
      school_id: school
    };
    let response = await apiCall("vendor/list/page", data);
    return response;
  },

  async createVendor(data) 
  {
    let response = await apiCall("vendor/add", data);
    return response;
  },

  async fetchVendorInfo(vendor_id) 
  {
    let data = {
      "vendor_id":vendor_id
    };
    let response = await apiCall("vendor/profile", data);
    return response;
  },

  async searchAllvendorAmounts(user_id, from, to) {
    let data = {
      user_id: user_id,
      from: from,
      to: to
    };
    let response = await apiCall("pocket_money/transaction_type_amounts/vendor", data);
    return response;
  },
  async getAllvendorAmounts(user_id) {
    let data = {
      user_id: user_id
    };
    let response = await apiCall("pocket_money/transaction_type_amounts/vendor", data);
    return response;
  },

  async fetchVendorCommissions(page, user) {
    let data = {
      page:page,
      user_id: user
    };
    let response = await apiCall("mobile/webapp/vendor_commissions", data);
    return response;
  },

  async fetchCommissionBalance(user) {
    let data = {
      user_id: user
    };
    let response = await apiCall("vendor/commissions/balance", data);
    return response;
  },
  async getAllvendorCommissions(user_id) {
    let data = {
      user_id: user_id
    };
    let response = await apiCall("pocket_money/commission_type_amounts/vendor", data);
    return response;
  },
  async searchAllCommissionAmounts(user_id, from, to) {
    let data = {
      user_id: user_id,
      from: from,
      to: to
    };
    let response = await apiCall("pocket_money/commission_type_amounts/vendor", data);
    return response;
  },
  async listAllVendorFloatBalances(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/float_balance/vendors/report", data);
    return response;
  },
  async searchAllVendorFloatBalances(page, school_id, search) {
    let data = {
      page: page,
      school_id: school_id,
      search: search
      
    };
    let response = await apiCall("mobile/webapp/float_balance/vendors/report", data);
    return response;
  },
  async fetchAllSchoolFloatBalances(data) {
    let response = await apiCall("bank/vendor_float_balance/school/all", data);
    return response;
  },
  async fetchVendorHighlights(vendor_user_id) {
    let data = {
      vendor_user_id: vendor_user_id
      
    };
    let response = await apiCall("bank/pocket_money/highlights/vendor", data);
    return response;
  },
  async listAllCommissionBalances(page) {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/commission_balance/vendors/report", data);
    return response;
  },
  async searchAllCommissionBalances(page, school_id, search) {
    let data = {
      page: page,
      school_id: school_id,
      search: search
      
    };
    let response = await apiCall("mobile/webapp/commission_balance/vendors/report", data);
    return response;
  },
  async fetchVendorCommissionsReport(page, user, startDate, endDate) {
    let data = {
      page:page,
      user_id: user,
      from: startDate,
      to: endDate
    };
    let response = await apiCall("mobile/webapp/vendor_commissions", data);
    return response;
  },
  async fetchVendorCommissionsPrintable(user, from, to) {
    let data = {
      user_id: user,
      from: from,
      to: to
    };
    let response = await apiCall("mobile/webapp/vendor_commissions/printable", data);
    return response;
  },
  async fetchVendorActivationsAndDeposits(page, user) {
    let data = {
      page:page,
      user_id: user
    };
    let response = await apiCall("mobile/webapp/deposits_and_activations/vendor", data);
    return response;
  },

  async searchVendorActivationsAndDeposits(page, user, school_id, startDate, endDate) {
    let data = {
      page:page,
      user_id: user,
      school_id: school_id,
      from: startDate,
      to: endDate,
      
    };
    let response = await apiCall("mobile/webapp/deposits_and_activations/vendor", data);
    return response;
  },

  async printAllVendorActivationsAndDeposits(user, school_id, startDate, endDate) {
      let data = {
        user_id: user,
      school_id: school_id,
      from: startDate,
      to: endDate 
      };
      let response = await apiCall("mobile/webapp/deposits_and_activations/vendor/print", data);
      return response;
    },
};
